import GdsApi from '~/glm/utils/gds-api';

export const ADDRESSLABEL = 'addresslabel';
export const RSVP = 'rsvp';
export const PEOPLE = 'people';

const fileNameOptions = {
  [ADDRESSLABEL]: 'My Address Labels.csv',
  [RSVP]: 'My Rsvp List.csv',
  [PEOPLE]: 'My Guest List.csv',
};

export const exportTypes = {
  [ADDRESSLABEL]: 'addresses',
  [RSVP]: 'rsvps',
  [PEOPLE]: 'all',
};

const supportedOptions = [ADDRESSLABEL, RSVP, PEOPLE];

export const downloadCSV = option => {
  if (!supportedOptions.includes(option)) {
    throw new Error('Not a supported export type');
  }

  const GDS_API_ENDPOINT = process.env.REACT_APP_GLM_GDS_API_ENDPOINT;
  const path = `${GDS_API_ENDPOINT}/v1/${option}/export`;
  const init = { headers: GdsApi.baseHeaders() };

  fetch(path, init)
    .then(response => response.blob())
    .then(response => {
      const fileName = fileNameOptions[option];
      // IE10+ has Blob, but not a[download]
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(response, fileName);
      } else {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(response);
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    })
    .catch(response => {
      GdsApi.handleRejectedFetch(response, path, init);
    });
};
